<script lang="ts">
  import QtySelector from '$lib/helpers/QtySelector.svelte';
  import QtySelectorMobile from '$lib/helpers/QtySelectorMobile.svelte';
  import { addToCart } from '$lib/js/cart';
  import { getFormattedPrice } from '$lib/js/helpers/prices'
	import {
		is_set_object,
		getProductFinalPriceWithTax,
	} from '$lib/js/helpers'
  import { onMount } from 'svelte';
  import { page } from '$app/stores';
  import { t } from 'svelte-i18n-lingui';
	import type { FullProduct } from '$lib/js/elasticsearch/types'

  export let product: FullProduct
  export let qtyselected = 1

  $: innerWidth = 0;

  const final_price = getProductFinalPriceWithTax(product);

  onMount(() => {
    if(is_set_object(product)) {
      product.cart_qty = qtyselected;
    }
  })

  async function addItemToCart(product: FullProduct) {
    await addToCart(product, qtyselected)
  }
</script>


<svelte:window bind:innerWidth/>

{#if product.stock.source_quantity > 0}
  <div class="product-buy">
    <div class="product-buy__inner">

      <div class="product-buy__wrapper">
        {#if $page.data.mobile === false || innerWidth > 768}
          <QtySelector bind:qty={qtyselected} prod={product} type="nullable"/>
        {:else}
          <p class="product-buy__price">{getFormattedPrice(final_price)}€</p>
          <QtySelectorMobile bind:qty={qtyselected}/>
        {/if}
      </div>

      <button class="u-btn" on:click="{()=> addItemToCart(product)}">
        <span class="icon icon-add-to-cart"></span>
        <p class="desktop">{$t`Add to cart`}</p>
        <p class="mobile">{$t({message: "Add", context: "\"Add to cart\" on small screens"})}</p>
      </button>

    </div>
  </div>
{:else}
  <div class="product-buy unavailable">
    <p class="no-stock">{$t`No stock`}</p>
  </div>
{/if}


<style lang="scss">
  .product-buy {
    position: relative;
    box-shadow: 0px -6px 8px 2px rgba(0, 0, 0, 0.08);
    
    @media (min-width: 769px) {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      overflow: hidden;
    }

    &:not(.unavailable) {
      @media (max-width: 768px) {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: var(--grey);
        z-index: 9;
        box-shadow: 0 4px 20px 10px rgba(0, 0, 0, 0.16);
      }
    }

    &__inner {
      display: flex;
      align-items: center;

      @media (max-width: 768px) {
        justify-content: space-between;
      }

      button.u-btn {
        padding: 0;
        height: 40px;
        flex-grow: 1;

        @media (max-width: 768px) {
          font-size: 14px;
        }

        @media (max-width: 768px) {
          height: auto;
          padding: 16px 10px;
        }

        .icon {
          margin-right: 8px;
        }

        p {
          display: inline-block;

          &.desktop {
            @media (max-width: 1200px) {
              display: none;
            }
          }

          &.mobile {
            @media (min-width: 1201px) {
              display: none;
            }
          }
        }
      }

      .u-btn--grey {
        background: var(--grey--b) !important;
        border-color: var(--grey--b) !important;

        &:hover {
          cursor: not-allowed;
        }
      }
    }

    &__wrapper {
      display: flex;
      align-items: flex-end;

      @media (max-width: 768px) {
        align-items: center;
        padding: 12px 20px;
      }
    }

    &__price {
      font-weight: 700;
      font-size: 26px;
      color: var(--main);
      margin-right: 15px;
    }

    p.no-stock {
      display: block;
      text-transform: uppercase;
      font-size: 18px;
      font-weight: 700;
      padding: 10px 20px;
      border: 2px solid var(--main);
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      text-align: center;
      color: var(--main);
      background: rgba(255, 255, 255, 0.5);
    }
  }
</style>
